import { Card } from "antd";
import { AlertTriangle, Calendar, Clock, X } from "lucide-react";
import React from "react";

const AnnouncementCard = ({ announcement, isSelected, onRemove, selectedId }) => {
  const { priority, icon: Icon, title, description, dateAnnounced, category, time } = announcement;

  return (
    <Card
      className={`
        group gradient rounded-2xl transform transition-all duration-300 ease-in-out hover:shadow-2xl dark:border-none
        ${category.toLowerCase().replace(/\s+/g, "-")}
        ${isSelected ? "opacity-100 translate-y-0 z-10" : "opacity-10 translate-y-4 z-0 pointer-events-none"}
      `}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -mr-32 -mt-32 opacity-10"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full -ml-24 -mb-24 opacity-10"></div>
      </div>

      <button
        className="absolute top-4 right-4 flex z-50 items-center justify-center p-1.5 rounded-xl bg-white/20 hover:bg-white/30 backdrop-blur-sm transition-all"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(selectedId);
        }}
      >
        <X className="w-3.5 h-3.5 pointer-events-none" />
      </button>

      <div className="relative z-10 flex flex-col md:flex-row gap-6 items-start">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110  duration-300 ">
            {Icon && <Icon className="w-8 h-8" />}
          </div>
        </div>

        <div className="flex-1 text-white">
          <div className="flex items-start justify-between gap-4 mb-3">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 font-medium text-[10px] uppercase tracking-wider bg-white/20 border-white/30 text-white">
                  {category}
                </span>
                  {priority === "high" && (
                    <span className={`flex items-center gap-1 justify-center rounded-md px-2 py-0.5 font-medium text-[10px] bg-red-500 text-white`}>
                        <>
                          <AlertTriangle className="w-3 h-3" /> Urgent
                        </>
                    </span>
                  )}
              </div>
              <h3 className="text-2xl mb-2 font-semibold">{title}</h3>
            </div>
          </div>

          <p className="text-white/90 text-[15px] leading-relaxed mb-4 font-normal">{description}</p>

          <div className="flex flex-wrap items-center gap-4 text-sm">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-lg">
              <Calendar className="w-4 h-4" />
              <span className="font-medium">{dateAnnounced}</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-lg">
              <Clock className="w-4 h-4" />
              <span className="font-medium">{time}</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AnnouncementCard;
